import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[cert-func]',
    standalone: false
})
export class CertFuncDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}